import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-58a768be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "problem" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "answer" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }

import { ref } from 'vue'
    import CheckBoxElem from './CheckBoxElem.vue'
    import RadioElem from './RadioElem.vue'
    import YesOrNoElem from './YesOrNoElem.vue'
    
export default /*#__PURE__*/_defineComponent({
  __name: 'item',
  props: ['data', 'index', 'examinationRecordId', 'noClick'],
  emits: ['changStatus', 'changSelected'],
  setup(__props, { emit: __emit }) {


    const props = __props
    const emit = __emit
    
    const itemData = ref({
        answerList: props.data.answerList,
        answers: props.data.answers,
        questionType: props.data.questionSnapshots.questionType,
        questionId:  props.data.questionId,
        questionSnapshots: props.data.questionSnapshots
    })

    // 类型判断 1 单选 2 多选 3 判断题
    // 答题状态 1 已做 2 未做 3 疑问
    const checkAnswer = ( idx: number, type: number, flag: boolean ) => {
        if ( props.noClick ) {
            return false
        }
        let answerList = itemData.value.answerList
        if ( type === 1 || type === 3) {
            answerList.length = 0
            answerList.push( idx )
        } else if ( type === 2 ) {
            let i = answerList.findIndex((item:number) => {
                return item === idx
            })
            if ( i !== -1 ) {
                answerList.splice(i, 1)
            }
            if ( !flag ) {
                answerList.push( idx )
            }
        }
        changeData(answerList, 1)
    }

    // 更新答题数据
    const changeData = (answers: any, state: number) => {
        itemData.value.answers.map((item:any, i: number) => {
            let idx = i+1
            if ( answers.indexOf(idx) !== -1 ) {
                item.isFlag = true
            } else {
                item.isFlag = false
            }
            return item
        })
        // 如果答案为空需要更变状态
        if ( answers.length === 0 ) {
            state = 2
        }
        answers = answers.map((i:number) => i+1)
        submitAnswers(answers, state)
    }

    const submitAnswers = (answers:any, state:any) => {
        emit('changSelected', props.data, answers, state )
    }

    const markHandler = () => {
        if ( props.noClick ) {
            return false
        }
        if ( props.data.mark ) {
            emit('changStatus', props.data, false)
        } else {
            emit('changStatus', props.data, true)
        }
    }


return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!

  return (_openBlock(), _createBlock(_component_el_col, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, [
          _createTextVNode("第" + _toDisplayString(__props.index+1) + "题", 1),
          _hoisted_2,
          _createTextVNode("【" + _toDisplayString(itemData.value.questionType === 1 ? '单选题' : itemData.value.questionType === 2 ? '多选题' : '判断') + "】", 1)
        ]),
        _createTextVNode(" " + _toDisplayString(itemData.value.questionSnapshots.content) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["mark", {cur: __props.data.mark}]),
          onClick: markHandler
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (itemData.value.questionType === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(RadioElem, {
                data: itemData.value,
                onChoose: checkAnswer
              }, null, 8, ["data"])
            ]))
          : (itemData.value.questionType === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(CheckBoxElem, {
                  data: itemData.value,
                  onChoose: checkAnswer
                }, null, 8, ["data"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(YesOrNoElem, {
                  data: itemData.value,
                  onChoose: checkAnswer
                }, null, 8, ["data"])
              ]))
      ])
    ]),
    _: 1
  }))
}
}

})